





















































import { Component, Vue } from "vue-property-decorator";

import LotteryItem from "@/components/LotteryItem.vue";

@Component({
    name: "GathererLink",
})
export default class GathererLink extends Vue {}
